export enum ProductType {
  pn2 = "Pico Neo 2 Eye",
  og = "Oculus Go",
  oq2 = "Oculus Quest 2",
  pg2 = "Pico G2",
  pn3 = "Pico neo 3 Eye",
}

export const productTypes = {
  pn2: "Pico Neo 2 Eye",
  og: "Oculus Go",
  oq2: "Oculus Quest 2",
  pg2: "Pico G2",
  pn3: "Pico neo 3 Eye",
};
